<template>
  <SelectItem
    :class="[props.disabled && 'disabled', 'dropdown-item select-item']"
    v-bind="props"
  >
    <SelectItemIndicator class="select-item-indicator">
      <i class="bx bx-check" />
    </SelectItemIndicator>
    <SelectItemText :class="props.textClass">
      <slot />
    </SelectItemText>
  </SelectItem>
</template>

<script setup>
import { SelectItem, SelectItemIndicator, SelectItemText } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  as: { type: null, required: false },
  asChild: { type: Boolean, required: false },
  class: { type: null, required: false },
  textClass: { type: null, required: false },
  disabled: { type: Boolean, required: false },
  textValue: { type: String, required: false },
  value: { type: [String, Number], required: true },
})
</script>

<style lang="scss" scoped>
.select-item-indicator {
  position: absolute;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  left: 0;
}

.select-item {
  padding-left: 1.5rem;
  display: flex;
  align-items: center;

  &[data-highlighted] {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  &[data-state="checked"] {
    color: var(--gu-drodpown-link-active-color);
    background-color: var(--gu-dropdown-link-active-bg);
    text-decoration: none;
  }
}
</style>
